exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flip-list-move[data-v-460dcc7a] {\n  transition: transform 0.5s;\n}\n.no-move[data-v-460dcc7a] {\n  transition: transform 0s;\n}\n.ghost[data-v-460dcc7a] {\n  visibility: hidden;\n}\n.list-group[data-v-460dcc7a] {\n  min-height: 20px;\n}\n.list-group-item[data-v-460dcc7a] {\n  cursor: move;\n}\n.list-group-item i[data-v-460dcc7a] {\n  cursor: pointer;\n}", ""]);

// exports
